"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateListener = void 0;
class StateListener {
    constructor(callback, db, key, debounceMillis = 50) {
        this.callback = callback;
        this.db = db;
        this.key = key;
        this.debounceMillis = debounceMillis;
        this.lastUpdateSent = 0;
        this.lastValue = null;
        this.debounceTimeout = null;
        this.callback = callback.bind(this);
        this.setStateOptimistic = this.setStateOptimistic.bind(this);
        this.sendUpdate = this.sendUpdate.bind(this);
        db.subscribe(key, (value) => {
            this.callback(value.value);
        });
    }
    onMessage(value) {
        this.callback(value.value);
    }
    sendUpdate() {
        if (this.debounceTimeout !== null) {
            window.clearTimeout(this.debounceTimeout);
            this.debounceTimeout = null;
        }
        this.db?.send({
            type: "push",
            action: { "type": "replace" },
            value: this.lastValue,
            key: this.key
        });
    }
    setStateOptimistic(value) {
        this.callback(value);
        this.lastValue = value;
        const now = performance.now();
        if (now - this.lastUpdateSent < this.debounceMillis) {
            if (this.debounceTimeout === null) {
                this.debounceTimeout = window.setTimeout(this.sendUpdate, this.debounceMillis);
            }
        }
        else {
            this.lastUpdateSent = now;
            this.sendUpdate();
        }
    }
}
exports.StateListener = StateListener;
